import React, { useEffect, useState } from "react";
import { Grid, Header, Divider, Table, label, Button } from "semantic-ui-react";
import { reduxForm, Field, FieldArray } from "redux-form";
import {
  renderTextField,
  amountsAre,
  renderOptionField,
  renderTextAreaField,
} from "../formcomponents";
import ImageFileUploadFileId from "../formcomponents/ImageFileUploadFileId";
import RecivedMoneyFieldArr from "./RecivedMoneyFieldArr";
import axios from "axios";
import {
  BaseUrlInvoice,
  ImageUrl,
  BaseImgUploadUrl,
} from "../formcomponents/Constants";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router";
import { userData } from "../store/userData";
import FileUpladArr from "./FileUplaad/FileUpladArr";
const ReciveMoney = (props) => {
  const { handleSubmit, pristine, reset, submitting } = props;
  const { id, catid } = useParams();
  const navigate = useNavigate();
  const [userDetail, setuserDetail] = useState("");
  const [totalAmount, settotalAmount] = useState("");
  const [buttonDisable, setbuttonDisable] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [downloadImage, setdownloadImage] = useState();
  const formatDateToYYYYMMDD = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const [uploadedImageList, setuploadedImageList] = useState([]);
  useEffect(() => {
    const userDetail = userData();

    setuserDetail(userDetail);

    if (id !== "null") {
      if (userDetail.userRole != 1) {
        setbuttonDisable(true);
      }
      getReciveMoneyDetails(id);
    } else {
      const today = new Date();
      props.initialize({
        receivedOn: formatDateToYYYYMMDD(today),

        itemList: [{}],

        fileList: [{}],
      });
    }
  }, [totalAmount]);
  const spentAs = [
    { text: "Cash", value: 1 },
    { text: "Credi Card", value: 2 },
    { text: "Cheque", value: 3 },
    { text: "Payment Link", value: 4 },
    { text: "Bank Transfer", value: 5 },
    { text: "BankTransferTO ENBD", value: 6 },
    { text: "Bank Transfer TO Rak Bank", value: 7 },
  ];

  const handleClick = (event, url) => {
    // 👇️ refers to the image element
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const getReciveMoneyDetails = (id) => {
    axios
      .post(BaseUrlInvoice + "accounts/getReceiveMoney", { receiveMoneyId: id })
      .then((res) => {
        preInitialForm(res.data);

        if (res.data.fileReference != "null") {
          setdownloadImage(res.data.fileReference);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const preInitialForm = (tempData) => {
    props.initialize({
      receiveMoneyId: id,
      receivedAs: tempData.receivedAs,
      receivedFrom: tempData.receivedFrom,
      receivedOn: tempData.receivedOn,
      reference: tempData.reference,
      amountsAre: tempData.amountsAre,
      itemList: tempData.itemList,
      fileReference: tempData.fileReference,
      remarks: tempData.remarks,
      fileList: [{}],
    });

    setuploadedImageList(tempData.fileList);
    settotalAmount(tempData.totalAmount);
  };

  const sumbitForm = (values) => {
    setIsSubmitting(true);
    console.log(JSON.stringify(values, null, 2));

    const currencyConversion = [
      { option: "AED", value: 1 },
      { option: "EUR", value: 3.93 },
      { option: "USD", value: 3.67 },
      { option: "INR", value: 22.59 },
    ];

    let tempArr = [];
    if (values.itemList != "") {
      values.itemList.forEach((item) => {
        const itemQty = item.itemQty;
        const unitPrice = item.unitPrice;
        const currency = item.currency;
        const filterItem = currencyConversion.find(
          (currencyItem) => currencyItem.option === currency
        );
        const total = Number(itemQty) * Number(unitPrice);
        const withTax = total + Number(item.taxRate || 0);
        const convertAmount = withTax * filterItem.value;
        console.log("total", convertAmount);

        // Include the itemId from the original item in tempArr
        tempArr.push({
          itemDetailId: item.itemDetailId,
          itemName: item.itemName,
          itemDescription: item.itemDescription,
          itemQty: item.itemQty,
          unitPrice: item.unitPrice,
          currency: item.currency,
          acccount: item.acccount,
          taxRate: item.taxRate,
          region: item.region,
          amount: convertAmount,
        });
      });
    }

    const imageList = [...values.fileList, ...uploadedImageList];

    const submitObject = {
      ...values,
      itemList: tempArr,
      fileList: imageList,
      userId: userDetail.userId,
      categoryId: catid, // Add imageList to the submitObject
    };
    console.log(JSON.stringify(submitObject, null, 2));
    axios
      .post(BaseUrlInvoice + "accounts/createReceiveMoney", submitObject)
      .then((res) => {
        console.log("kabxiasbixbsbcxs", res.data);
        if (res.data.errCode === 200) {
          Swal.fire("New Record Added");
          navigate(`/list-recive-money/${res.data.categoryId}`);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div>
      <Grid.Row>
        <Header dividing size="huge" as="h1">
          Receive Money
        </Header>
      </Grid.Row>
      <Divider hidden /> <Divider hidden />
      <Grid.Row>
        <Button type="submit" primary onClick={() => navigate(-1)}>
          Go Back
        </Button>

        <Button
          type="submit"
          floated="right"
          positive
          // disabled={buttonDisable || isSubmitting}
          onClick={handleSubmit((values) =>
            sumbitForm({
              ...values,
            })
          )}
        >
          Save
        </Button>
        <Button
          floated="right"
          negative
          disabled={pristine || submitting}
          onClick={reset}
        >
          Cancel
        </Button>
      </Grid.Row>
      <br />
      <Divider hidden />
      <Grid.Row>
        <Grid columns="seven">
          <Grid.Row>
            <Grid.Column>
              <Field
                name="receivedAs"
                label="Received As"
                options={spentAs}
                component={renderOptionField}
              />
            </Grid.Column>
            <Grid.Column>
              {" "}
              <Field
                name="receivedFrom"
                label="From"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              {" "}
              <Field
                name="receivedOn"
                label="Date"
                type="date"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              {" "}
              <Field
                name="reference"
                label="Reference"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column> </Grid.Column>
            <Grid.Column> </Grid.Column>
            <Grid.Column>
              <Field
                name="amountsAre"
                label="Amounts Are"
                options={amountsAre}
                component={renderOptionField}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row>
      <Divider hidden /> <Divider hidden />
      {/* <Table fixed>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>
              <Field
                name="receivedAs"
                label="Received As"
                type="text"
                component={renderTextField}
              />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <Field
                name="receivedFrom"
                label="From"
                type="text"
                component={renderTextField}
              />
            </Table.HeaderCell>
            <Table.HeaderCell>
              {" "}
              <Field
                name="receivedOn"
                label="Date"
                type="date"
                component={renderTextField}
              />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <Field
                name="Reference"
                label="reference"
                type="text"
                component={renderTextField}
              />
            </Table.HeaderCell>
            <Table.HeaderCell></Table.HeaderCell>
            <Table.HeaderCell></Table.HeaderCell>

            <Table.HeaderCell>
              {" "}
              <Field
                name="Amounts Are"
                label="amountsAre"
                type="text"
                component={renderTextField}
              />
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
      </Table> */}
      <FieldArray
        name="itemList"
        totalAmountget={totalAmount}
        component={RecivedMoneyFieldArr}
      />
      <FieldArray name="fileList" component={FileUpladArr} />
      {/* <Grid.Row>
        <Grid columns="four">
          <Grid.Row>
            <Grid.Column></Grid.Column>
            <Grid.Column>
              {" "}
              {id != "null" && (
                <>
                  <img
                    src={ImageUrl + downloadImage}
                    height="150px"
                    width="150px"
                  />
                  <Button
                    positive
                    onClick={(event) =>
                      handleClick(event, ImageUrl + downloadImage)
                    }
                  >
                    Download File
                  </Button>
                </>
              )}
            </Grid.Column>
            <Grid.Column></Grid.Column>
            <Grid.Column>
              {" "}
              <div
                style={{
                  marginTop: "25px",
                }}
              >
                <Field
                  name="fileReference"
                  type="file"
                  component={ImageFileUploadFileId}
                  label="File"
                />
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row> */}
      {uploadedImageList.length > 0 && (
        <Table celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>File Name</Table.HeaderCell>
              <Table.HeaderCell>Download Link</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {uploadedImageList.map((item, index) => (
              <Table.Row key={index}>
                <Table.Cell collapsing>{item.fileTypeName}</Table.Cell>
                <Table.Cell collapsing>
                  <p
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      window.open(
                        ImageUrl + item.fileName,
                        "_blank",
                        "noopener,noreferrer"
                      )
                    }
                  >
                    Download
                  </p>
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      )}
      <Divider hidden />
      <Field name="remarks" component={renderTextAreaField} label="Remarks" />
      <br />
    </div>
  );
};

export default reduxForm({
  form: "ReciveMoney",
})(ReciveMoney);
